/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BackfillSyncEntitiesRequest} from '@cash-web/protos/squareup/cash/clientsync/service.pb'
import {BackfillSyncEntitiesResponse} from '@cash-web/protos/squareup/cash/clientsync/service.pb'


export const backfillSyncEntities = (request:BackfillSyncEntitiesRequest, options?: CashRequestOptions) => post<BackfillSyncEntitiesRequest, BackfillSyncEntitiesResponse>("/2.0/cash/backfill-sync-entities", request, {...options, rejectOnError: true })